<template>
  <div class="auth">
    <h3>Смена пароля</h3>
    <div v-if="errors.length">
      <div v-for="(error, key) in errors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div class="auth__form">
      <div class="auth__formDiv">
        <label>Новый пароль</label>
        <input
          v-model="newPass"
          tabindex="2"
          name="password"
          :type="showPass ? 'text' : 'password'"
        />
        <img @click="showPass = !showPass" src="@/profile/assets/icons/input-eye.svg" alt="eye">
      </div>
      <div class="auth__formDiv">
        <label>Подтвердите пароль</label>
        <input
          v-model="confirmNewPass"
          tabindex="2"
          name="password"
          :type="showConfPass ? 'text' : 'password'"
        />
        <img @click="showConfPass = !showConfPass" src="@/profile/assets/icons/input-eye.svg" alt="eye">
      </div>
      <div class="auth__details">
        <span class="auth__passwordRules">
          В пароле разрешены латинские буквы, цифры, дефис и подчеркивание.
          <br />
          Длина пароля должна быть не меньше 6-ти символов
        </span>
      </div>
      <div class="auth__btnBlock">
        <button @click="sendData" class="auth__submit">Сохранить</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      newPass: "",
      confirmNewPass: "",
      errors: [],
      showPass: false,
      showConfPass: false
    };
  },
  methods: {
    async sendData() {
      if (this.newPass != this.confirmNewPass) {
        this.errors = [];
        this.errors.push("Пароли не совпадают");
      } else if (this.newPass.length < 6) {
        this.errors = [];
        this.errors.push("Пароль не может быть меньше 6-ти символов");
      } else {
        let params = {
          action: "change-pass",
          object: "cpa",
          forgot: true,
          new_password: this.newPass,
          token: this.$myApp.token.get()
        };
        let api = await this.$api2.get(params);
        if (api.error) {
          this.errors = [];
          this.errors = api.errors;
        }
        if (api.success) {
          this.$myApp.auth.set(false);
          this.$router.push({ name: "contracts" });
        }
      }
    }
  }
};
</script>